import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";

var _templateObject, _templateObject2;

var _excluded = ["expanded", "onChange", "showDividerBottom", "showDividerTop"],
    _excluded2 = ["allowIconRotation", "iconRotationDuration", "children", "align", "hoverColor", "buttonProps"],
    _excluded3 = ["children", "CollapsibleProps"];
import React from "react";
import { css, hoverColorProp, styled } from "@catchoftheday/theme";
import { noop, useControlled } from "@catchoftheday/utilities";
import { Box } from "../Box";
import { Collapsible } from "../Collapsible";
import { Flex } from "../Flex";
import { IconDownArrow } from "../Icon";
import { Text } from "../Text";
import { jsx as ___EmotionJSX } from "@emotion/react";
var Context = /*#__PURE__*/React.createContext(null);
export var Accordion = function Accordion(_ref) {
  var _expanded = _ref.expanded,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? noop : _ref$onChange,
      _ref$showDividerBotto = _ref.showDividerBottom,
      showDividerBottom = _ref$showDividerBotto === void 0 ? true : _ref$showDividerBotto,
      _ref$showDividerTop = _ref.showDividerTop,
      showDividerTop = _ref$showDividerTop === void 0 ? true : _ref$showDividerTop,
      boxProps = _objectWithoutProperties(_ref, _excluded);

  var _useControlled = useControlled(false, _expanded, onChange),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      expanded = _useControlled2[0],
      setExpanded = _useControlled2[1];

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];

  return ___EmotionJSX(Context.Provider, {
    value: {
      expanded: expanded,
      setExpanded: setExpanded,
      focused: focused,
      setFocused: setFocused
    }
  }, ___EmotionJSX(Box, _extends({
    borderTop: showDividerTop ? "1px solid #ddd" : undefined,
    borderBottom: showDividerBottom ? "1px solid #ddd" : undefined
  }, boxProps)));
};
export var AccordionSummary = function AccordionSummary(_ref2) {
  var _boxProps$fontWeight;

  var _ref2$allowIconRotati = _ref2.allowIconRotation,
      allowIconRotation = _ref2$allowIconRotati === void 0 ? true : _ref2$allowIconRotati,
      _ref2$iconRotationDur = _ref2.iconRotationDuration,
      iconRotationDuration = _ref2$iconRotationDur === void 0 ? 200 : _ref2$iconRotationDur,
      children = _ref2.children,
      align = _ref2.align,
      _ref2$hoverColor = _ref2.hoverColor,
      hoverColor = _ref2$hoverColor === void 0 ? "secondaryDark" : _ref2$hoverColor,
      buttonProps = _ref2.buttonProps,
      boxProps = _objectWithoutProperties(_ref2, _excluded2);

  var context = React.useContext(Context);

  if (!context) {
    throw new Error("<AccordionSummary /> must be rendered inside an <Accordion />");
  }

  var expanded = context.expanded,
      setExpanded = context.setExpanded,
      focused = context.focused,
      setFocused = context.setFocused;
  var rotationStyles = allowIconRotation ? {
    transform: "rotate(".concat(expanded ? 180 : 0, "deg)"),
    transition: "transform ".concat(iconRotationDuration, "ms ease-in-out")
  } : undefined;
  return ___EmotionJSX(AccordionSummaryContainer, _extends({
    tabIndex: 0,
    onKeyPress: function onKeyPress(e) {
      var _boxProps$onKeyPress;

      (_boxProps$onKeyPress = boxProps.onKeyPress) === null || _boxProps$onKeyPress === void 0 ? void 0 : _boxProps$onKeyPress.call(boxProps, e);

      if (e.key === "Enter") {
        setExpanded(function (val) {
          return !val;
        });
      }
    },
    onFocus: function onFocus(e) {
      var _boxProps$onFocus;

      (_boxProps$onFocus = boxProps.onFocus) === null || _boxProps$onFocus === void 0 ? void 0 : _boxProps$onFocus.call(boxProps, e);
      setFocused(true);
    },
    onBlur: function onBlur(e) {
      var _boxProps$onBlur;

      (_boxProps$onBlur = boxProps.onBlur) === null || _boxProps$onBlur === void 0 ? void 0 : _boxProps$onBlur.call(boxProps, e);
      setFocused(false);
    },
    role: "button",
    "aria-expanded": expanded,
    onClick: function onClick() {
      return setExpanded(function (val) {
        return !val;
      });
    },
    position: "relative",
    alignItems: "center",
    cursor: "pointer",
    padding: "1.375rem 2rem 1.3755rem 1rem",
    hoverColor: hoverColor
  }, boxProps), ___EmotionJSX(Box, {
    flexGrow: 1
  }, typeof children === "string" || typeof children === "number" ? ___EmotionJSX(Text, {
    margin: 0,
    fontSize: boxProps.fontSize,
    fontWeight: (_boxProps$fontWeight = boxProps.fontWeight) !== null && _boxProps$fontWeight !== void 0 ? _boxProps$fontWeight : 600,
    textAlign: align,
    color: "inherit"
  }, children) : typeof children === "function" ? children({
    focused: focused
  }) : children), ___EmotionJSX(Flex, _extends({
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "0",
    right: "0",
    height: "100%",
    width: "48px"
  }, buttonProps), ___EmotionJSX(Box, {
    style: rotationStyles
  }, ___EmotionJSX(IconDownArrow, {
    height: 12,
    width: 12
  }))));
};
var AccordionSummaryContainer = styled(Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    &:hover {\n      svg {\n        ", ";\n      }\n      ", ";\n    }\n\n    &:focus {\n      outline: none;\n    }\n\n    &:focus-visible {\n      ", ";\n      svg {\n        ", ";\n      }\n    }\n  "])), hoverColorProp(props), hoverColorProp(props), hoverColorProp(props), hoverColorProp(props));
});
export var AccordionDetails = function AccordionDetails(_ref3) {
  var _boxProps$fontWeight2;

  var children = _ref3.children,
      CollapsibleProps = _ref3.CollapsibleProps,
      boxProps = _objectWithoutProperties(_ref3, _excluded3);

  var context = React.useContext(Context);

  if (!context) {
    throw new Error("<AccordionSummary /> must be rendered inside an <Accordion />");
  }

  var expanded = context.expanded;
  return ___EmotionJSX(Collapsible, _extends({
    show: expanded
  }, CollapsibleProps), ___EmotionJSX(Box, _extends({
    padding: "0rem 1rem 1.375rem 1rem"
  }, boxProps), typeof children === "string" ? ___EmotionJSX(Text, {
    margin: 0,
    fontSize: boxProps.fontSize,
    fontWeight: (_boxProps$fontWeight2 = boxProps.fontWeight) !== null && _boxProps$fontWeight2 !== void 0 ? _boxProps$fontWeight2 : 600
  }, children) : children));
};
Accordion.displayName = "Accordion";
export default Accordion;